import React, { useEffect, useState, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
interface User {
  id: string;
  email: string;
  role: {
    type: 'super_admin' | 'client_admin' | 'org_admin' | 'org_member';
  };
}
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  signInWithGoogle: () => Promise<void>;
  signInWithEmail: (email: string, password: string) => Promise<void>;
  verifyOTP: (otp: string) => Promise<void>;
  logout: () => Promise<void>;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  // Mock auth functions for demo
  const signInWithGoogle = async () => {
    // Simulate Google auth
    setUser({
      id: '1',
      email: 'admin@example.com',
      role: {
        type: 'super_admin'
      }
    });
    setIsAuthenticated(true);
  };
  const signInWithEmail = async (email: string, password: string) => {
    // Simulate email auth
    setUser({
      id: '1',
      email,
      role: {
        type: 'super_admin'
      }
    });
    setIsAuthenticated(true);
  };
  const verifyOTP = async (otp: string) => {
    // Simulate OTP verification
    setIsAuthenticated(true);
  };
  const logout = async () => {
    setUser(null);
    setIsAuthenticated(false);
    navigate('/login');
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated,
    signInWithGoogle,
    signInWithEmail,
    verifyOTP,
    logout
  }} data-id="element-1604">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};